/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Error_Deleting_NoteInputs */

const en_read_along_error_deleting_note = /** @type {(inputs: Read_Along_Error_Deleting_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error deleting note`)
};

const es_read_along_error_deleting_note = /** @type {(inputs: Read_Along_Error_Deleting_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al eliminar la nota`)
};

/**
* | output |
* | --- |
* | "Error deleting note" |
*
* @param {Read_Along_Error_Deleting_NoteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_error_deleting_note = /** @type {((inputs?: Read_Along_Error_Deleting_NoteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Error_Deleting_NoteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_error_deleting_note(inputs)
	return en_read_along_error_deleting_note(inputs)
});